import { useCallback, useState } from 'react'

export const useRefreshMarker = (markerName: string) => {
	const [refreshMarker, setRefreshMarker] = useState<symbol | undefined>(undefined)
	const refresh = useCallback(() => setRefreshMarker(Symbol(markerName)), [setRefreshMarker])

	return [refreshMarker, refresh] as const
}
